<script lang="ts">
	import GdprCheckbox from "./GdprCheckbox.svelte";
	import EmailMarketingCheckbox from "./EmailMarketingCheckbox.svelte";
	import RecaptchaDisclaimer from "./RecaptchaDisclaimer.svelte";
	import Button from "../Button.svelte";
	import Message from "../Message.svelte";
	import translations from "./FormFooter.translations.json";
	import arrowRight from "../../../../core/assets/icons/arrow-right.svg?raw";
	import { getTranslate } from "../../utils/getTranslate.js";

	export let loading = false;
	export let error = false;
	/** Breakpoint from which checkboxes and submit button sit in one row. */
	export let rowFrom: "lg" | "xl" | null = "xl";
	let actionsClass = "p-2 md:p-4 xl:p-8";
	export { actionsClass as class };
	export let checkboxClass = "justify-start";
	export let errorClass = "";
	export let disclaimerClass = "";

	const translate = getTranslate(translations);

	const rowClasses = {
		lg: { actions: "lg:flex-row lg:items-center", checkboxes: "lg:flex-1" },
		xl: { actions: "xl:flex-row xl:items-center", checkboxes: "xl:flex-1" },
	};
	$: row = rowFrom ? rowClasses[rowFrom] : { actions: "", checkboxes: "" };
</script>

<div class="flex flex-col justify-between gap-5 {row.actions} {actionsClass}">
	<div class="flex min-w-0 flex-col gap-2 {row.checkboxes}">
		<GdprCheckbox class={checkboxClass} />
		<EmailMarketingCheckbox class={checkboxClass} />
	</div>
	<div class="shrink-0">
		<Button class="mx-[initial]" icon={arrowRight} type="submit" disabled={loading} variant="primary">
			{#if loading}
				{translate("submitting")}…
			{:else}
				{translate("submit")}
			{/if}
		</Button>
	</div>
</div>

{#if error}
	<Message variant="error" class={errorClass}>{translate("somethingWrong")}</Message>
{/if}

<RecaptchaDisclaimer class={disclaimerClass} />
